(function () {
  'use strict';
  /**
   * @ngdoc overview
   * @name com.module.about
   * @module
   * @description
   * @requires loopbackApp
   *
   * The `com.module.core` module provides services for interacting with
   * the models exposed by the LoopBack server via the REST API.
   *
   */
  angular.module('com.module.about', []);

})();
